export enum AlertsChartType {
  OPEN = 'Open',
  REOPEN = 'Reopen',
  CLOSED = 'Closed',
  TOTAL = 'Total',
}

export enum AlertsChartPeriod {
  LAST_WEEK = 'Week',
  LAST_MONTH = 'Month',
  LAST_THREE_MONTHS = '3 Months',
}

export enum AlertsUnitOfTime {
  DAYS = 'Days',
  WEEKS = 'Weeks',
  MONTHS = 'Months',
}
